const DOWNGRADE_COPY = {
    'enterprise->growth': {
        title: 'Are you sure?',
        message: 'Downgrading reduces your transactions limit to 20k per month, reduces custom integrations from 3 to 1, and removes priority support.',
    },
    'enterprise->connector': {
        title: 'Are you sure?',
        message: 'Downgrading reduces your transactions limit to 10k per month, removes Power Data including Click Activity Logs, excludes custom integrations, restricts syncs to weekly, and removes priority support.',
    },
    'growth->connector': {
        title: 'Are you sure?',
        message: 'Downgrading reduces your transactions limit to 10k per month, removes Power Data including Click Activity Logs, excludes custom integrations, and restricts syncs to weekly.',
    },
};

const KNOWN_TIERS = ['enterprise', 'growth', 'connector'];

export function getPlanTier (name = '') {
    const lowerName = name.toLowerCase();
    return KNOWN_TIERS.find((tier) => lowerName.includes(tier)) || null;
}

export function isDowngrade (currentPlan, targetPlan) {
    const currentPrice = Number(currentPlan?.price);
    const targetPrice = Number(targetPlan?.price?.monthly);
    return Number.isFinite(currentPrice) && Number.isFinite(targetPrice) && targetPrice < currentPrice;
}

export function getDowngradeCopy (currentPlan, targetPlan) {
    const fromTier = getPlanTier(currentPlan?.name);
    const toTier = getPlanTier(targetPlan?.name);
    if (!fromTier || !toTier) {
        return null;
    }
    return DOWNGRADE_COPY[`${fromTier}->${toTier}`] || null;
}
